export const allQRByLocationId = {

    GET_AllQRByLocationId: " GET_AllQRByLocationId"
}